import { render, staticRenderFns } from "./NotificacioncontactoGrid.vue?vue&type=template&id=12c38eb3"
import script from "./NotificacioncontactoGrid.vue?vue&type=script&lang=js"
export * from "./NotificacioncontactoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports